export default {
  loadingScheme: 'Schemat załadunku',
  partNoPlaceholder: 'Wprowadź numer części',
  noAssetQualificationsMatch: 'Części "{part}" nie można przetworzyć w piecu "{asset}".',
  noMatchedRecipeFound: 'Części "{part}" nie można przetworzyć w piecu "{asset}" i recepturze "{recipe}".',
  amountDoesNotMatch: 'Maksymalna liczba części "{part}" została przekroczona. Dozwolone jest załadowanie części "{max}", ale załadowano części "{actual}".',
  totalWeight: 'Łączna waga',
};
